<div style="display: flex; flex-direction: column; gap: 24px; width: 100%; padding: 16px 24px 16px 24px; height: 100%; overflow-y: auto; box-sizing: border-box">
  <div *ngIf="nessunDato" class="info-box" style="height: fit-content; padding: 32px 16px">
    <mat-icon class="info-box__icon">warning</mat-icon>
    <div class="info-box__text">{{ messaggioNessunDato }}</div>
  </div>

  <ng-container *ngIf="!nessunDato">
    <div
      *ngIf="heatmap.length"
      style="display: flex; flex-direction: column; width: 100%; height: fit-content; padding: 16px; border-radius: 8px; box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2); box-sizing: border-box"
    >
      <h3 style="text-align: center; margin: 0 0 8px 0">Heatmap rischio per parametro</h3>
      <ebw-monorepo-rischio-analitico-heatmap-chart [celle]="heatmap" [ordinePunti]="ordinePunti" style="width: 100%"></ebw-monorepo-rischio-analitico-heatmap-chart>
    </div>
    <div style="width: 100%; height: fit-content; padding: 16px; border-radius: 8px; box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2); box-sizing: border-box">
      <h3 style="text-align: center; margin: 0 0 8px 0">Osservazioni per classe di rischio</h3>
      <table mat-table [dataSource]="dataSource" style="width: 100%; min-height: 50%">
        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <ng-container matColumnDef="point">
          <th mat-header-cell *matHeaderCellDef>Punto</th>
          <td mat-cell *matCellDef="let element">{{ element.point }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="r5">
          <th mat-header-cell *matHeaderCellDef>R5</th>
          <td mat-cell *matCellDef="let element">{{ element.r5 }}</td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="r4">
          <th mat-header-cell *matHeaderCellDef>R4</th>
          <td mat-cell *matCellDef="let element">{{ element.r4 }}</td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="r3">
          <th mat-header-cell *matHeaderCellDef>R3</th>
          <td mat-cell *matCellDef="let element">{{ element.r3 }}</td>
        </ng-container>

        <ng-container matColumnDef="r2">
          <th mat-header-cell *matHeaderCellDef>R2</th>
          <td mat-cell *matCellDef="let element">{{ element.r2 }}</td>
        </ng-container>

        <ng-container matColumnDef="r1">
          <th mat-header-cell *matHeaderCellDef>R1</th>
          <td mat-cell *matCellDef="let element">{{ element.r1 }}</td>
        </ng-container>

        <ng-container matColumnDef="loq">
          <th mat-header-cell *matHeaderCellDef>< Loq</th>
          <td mat-cell *matCellDef="let element">{{ element.loq }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </ng-container>
</div>
